import React, { useEffect, useRef, useState } from "react";
import { Drawer, Select, DatePicker, Button, Spin, Tooltip } from "antd";
import { FullscreenExitOutlined, LoadingOutlined } from "@ant-design/icons";
import SerialTimeGraphics from "./SerialTimeGraphic";
import { getSerialTimeData } from "../services/api/marker.service";
import dayjs from "dayjs";

const { Option } = Select;
const { RangePicker } = DatePicker;

const mockVariables = [
  { variableName: "Temperatura del agua", variableId: 3, unit: "Cº" },
  { variableName: "Velocidad del viento", variableId: 432, unit: "m/s" },
  { variableName: "Velocidad Agua Este", variableId: 34, unit: "mm/s" },
  { variableName: "Velocidad Agua Norte", variableId: 35, unit: "mm/s" },
];

const antIcon = <LoadingOutlined style={{ fontSize: 16 }} spin />;

export const SerialTimePanel = ({ handleDrawerClose, marker }) => {
  const [data, setData] = useState(null);
  const variables = useRef(mockVariables);
  const [selectedVariableIds, setSelectedVariableIds] = useState([]);
  // const [dateRange, setDateRange] = useState([
  //   dayjs().subtract(3, "day").startOf("day"),
  //   dayjs().startOf("day"),
  // ]);
  const [dateRange, setDateRange] = useState([
    dayjs("2024-08-05").startOf("day"),
    dayjs("2024-08-07").startOf("day"),
  ]);
  const [initDone, setInitDone] = useState(false);
  const [loading, setLoading] = useState(false);
  const chartRef = useRef(null);

  // const getVariables = async () => {
  //   // TODO: Replace with API call
  //   debugger;
  //   variables.current = mockVariables;
  // };

  const getData = async () => {
    setData(null);
    setLoading(true);
    const from = dateRange[0].format("YYYY-MM-DDT00:00:00");
    const to = dateRange[1].add(1, "day").format("YYYY-MM-DDT00:00:00");

    try {
      const dataArrays = await Promise.all(
        selectedVariableIds.map(async (variableId) => {
          const result = await getSerialTimeData(
            marker.domain,
            marker.id,
            variableId,
            from,
            to
          );

          const variable = variables.current.find(
            (v) => v.variableId === variableId
          );
          const variableName = variable ? variable.variableName : variableId;

          return result.map((val) => {
            return {
              date: val.date,
              [variableName]: parseFloat(val.value.toFixed(4)),
            };
          });
        })
      );

      const mergedData = mergeDataArrays(dataArrays);
      setData(mergedData);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const mergeDataArrays = (dataArrays) => {
    const dataMap = new Map();

    dataArrays.forEach((array) => {
      array.forEach((item) => {
        const date = item.date;
        if (!dataMap.has(date)) {
          dataMap.set(date, { date });
        }
        const dataItem = dataMap.get(date);
        Object.keys(item).forEach((key) => {
          if (key !== "date") {
            dataItem[key] = item[key];
          }
        });
      });
    });

    return Array.from(dataMap.values()).sort(
      (a, b) => new Date(a.date) - new Date(b.date)
    );
  };

  const handleDateRangeChange = (dates) => {
    setDateRange(dates);
  };

  const handleZoomOut = () => {
    if (chartRef.current) {
      chartRef.current.zoomOut();
    }
  };

  const init = async () => {
    // await getVariables();
    // const defaultVariableIds = variables.current.map((v) => v.variableId);
    // setSelectedVariableIds([defaultVariableIds[0]]);
    // setInitDone(true);
  };

  useEffect(() => {
    // init();
  }, []);

  const series = selectedVariableIds.map((variableId) => {
    const variable = variables.current.find((v) => v.variableId === variableId);
    return {
      name: variable ? variable.variableName : variableId,
      unit: variable.unit,
    };
  });

  const handleSelectOnChange = (newSelectedVariableIds) => {
    if (newSelectedVariableIds.length > 0) {
      const newVariable = variables.current.find(
        (v) =>
          v.variableId ===
          newSelectedVariableIds[newSelectedVariableIds.length - 1]
      );

      const selectedUnits = newSelectedVariableIds.map((id) => {
        const variable = variables.current.find((v) => v.variableId === id);
        return variable?.unit;
      });

      const hasDifferentUnits = new Set(selectedUnits).size > 1;

      if (hasDifferentUnits) {
        // Mantener solo la última variable seleccionada
        setSelectedVariableIds([newVariable.variableId]);
      } else {
        setSelectedVariableIds(newSelectedVariableIds);
      }
    } else {
      setSelectedVariableIds([]);
    }
  };

  return (
    <Drawer
      placement="bottom"
      height={400}
      onClose={handleDrawerClose}
      visible={true}
      headerStyle={{ display: "none" }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 16,
        }}
      >
        <div style={{ display: "flex", columnGap: 10 }}>
          <Select
            mode="multiple"
            placeholder="Seleccione variables"
            style={{ width: 500, marginLeft: 35 }}
            onChange={handleSelectOnChange}
            value={selectedVariableIds}
            id="variableIds"
          >
            {variables.current.map((variable) => (
              <Option key={variable.variableId} value={variable.variableId}>
                {variable.variableName + " (" + variable.unit + ")"}
              </Option>
            ))}
          </Select>

          <RangePicker
            onChange={handleDateRangeChange}
            value={dateRange}
            format="YYYY-MM-DD"
            popupClassName="custom-calendar-popup-white"
          />
          <Button type="primary" onClick={getData} disabled={loading}>
            Crear gráfica{" "}
            {loading && (
              <Spin
                indicator={antIcon}
                style={{ marginLeft: 8, marginBottom: 5 }}
              />
            )}
          </Button>
          <Tooltip title="Zoom Out">
            <Button
              icon={<FullscreenExitOutlined style={{ fontSize: 22 }} />}
              onClick={handleZoomOut}
            />
          </Tooltip>
        </div>
        {/* <img
          src={`/logos/${marker.domain.sourceId}.png`}
          width={160}
          style={{ marginRight: 10 }}
        /> */}
      </div>
      <SerialTimeGraphics ref={chartRef} data={data} series={series} />
    </Drawer>
  );
};
